<template>
  <div id="app">
    <h1
      v-if="loggedIn"
      class="main-title"
    >shopping list</h1>
    <Login v-if="!loggedIn" />
    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Login from "./components/Login.vue";

export default {
  components: {
    Login,
  },
  computed: {
    ...mapState(["list", "loggedIn"]),
  },
  watch: {
    list: {
      handler(value) {
        this.$store.commit("STORE_LIST", value);
      },
      deep: true,
    },
  },
  created() {
    const authData = JSON.parse(localStorage.getItem("authData"));

    if (!authData) {
      return;
    }

    const expirationDate = Date.parse(localStorage.getItem("authExpiration"));
    const now = Date.parse(new Date());

    if (now >= expirationDate) {
      // Token invalid, swap refresh token for new token
      this.$store.dispatch("refreshExpiredToken", authData.refreshToken);
    } else {
      // Token still valid
      this.$store.state.userId = authData.userId;
      this.$store.state.idToken = authData.idToken;
      this.$store.state.loggedIn = true;
    }
  },
};
</script>

<style>
@import "assets/styles/tailwind.postcss";

body,
html {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

.container {
  @apply mx-auto;
}

.main-title {
  text-align: left;
  color: white;
  padding: 10px 0px 20px 0px;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.26);
  position: block;
  width: 95%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
</style>
